import { render } from "./ScrollHorizontal.vue?vue&type=template&id=3745d1ca"
import script from "./ScrollHorizontal.vue?vue&type=script&lang=js"
export * from "./ScrollHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__